<template>
	<section class="main-content contentblocks">
		<div class="row row-header align-center white">
			<div v-if="contentBlocksContent.length">
				<h2 class="subtitle">
					{{ contentBlocksSubtitle }}
				</h2>
				<div v-parse-links v-html="contentBlocksContent" />
			</div>
		</div>
		<div
			v-for="(block, index) in contentblocks"
			:key="block.ID"
			class="row contentblock"
			:class="(block.embedCode, 'has-video')"
		>
			<div class="row contentblock" :class="index % 2 === 0 ? 'right' : 'left'">
				<div class="columns column6 contentblock-content" :class="index % 2 === 0 ? 'right' : 'left'">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<div class="side-curve" :class="index % 2 === 0 ? 'right' : 'left'" />
				<div v-if="block.embedCode" class="contentblock-image">
					<iframe loading="lazy" :src="block.embedCode + '?&modestbranding=1&rel=0'"></iframe>
				</div>
				<div v-else class="contentblock-image">
					<picture>
						<source v-if="block.imageWebp" :srcset="block.imageWebp" type="image/webp" />
						<source :srcset="block.image" />
						<img loading="lazy" :src="block.image" :alt="block.imageAlt" />
					</picture>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	contentblocks: { type: Array, default: () => [] },
	contentBlocksContent: { type: String, default: '' },
	contentBlocksSubtitle: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: $contentblock-background-color;
}

.background-light {
	background: $alternating-background-color;
}

.contentblock {
	margin: 20px auto;
	position: relative;
	display: flex;
	flex-flow: row nowrap;
	justify-content: stretch;
	min-height: 540px;
	width: 100%;
	float: none;
	overflow: hidden;

	&.right {
		flex-flow: row-reverse nowrap;
	}
}

.row-header {
	max-width: 1000px;
}

.contentblock-image {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	width: 58%;
	z-index: 1;
	float: none;

	iframe {
		width: 100%;
		height: 100%;
	}
}

.contentblock-content {
	background: $alternating-background-color;
	padding: 90px 90px 90px 20px;
	margin: 0;
	position: relative;
	z-index: 2;
	float: none;
	width: 42%;
	display: flex;
	flex-flow: column wrap;
	justify-content: center;

	&.left {
		padding: 90px 20px 90px 90px;
	}
}

.row:nth-child(even) .contentblock-image {
	left: 0;
	right: auto;
}

.contentblock-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.side-curve {
	width: 240px;
	background: url('~/assets/images/contentblock-curve-right.svg') no-repeat top -10px right;
	background-size: cover;
	float: none;
	position: absolute;
	right: 42%;
	top: 0;
	bottom: 0;
	z-index: 10;

	&.left {
		background: url('~/assets/images/contentblock-curve-left.svg') no-repeat top -10px right;
		background-size: cover;
		left: 42%;
	}
}

@media (max-width: 920px) {
	.contentblock-image {
		width: 100%;
		position: relative;
		inset: auto !important;

		iframe {
			min-height: 400px;
		}
	}

	.contentblock,
	.contentblock.right {
		display: flex;
		flex-flow: wrap column-reverse;
		min-height: inherit;
		max-height: inherit;
	}

	.contentblock-content.left,
	.contentblock-content.right {
		margin: 0 auto 50px;
		padding: 0 30px 50px;
		width: 100%;
	}

	.side-curve,
	.side-curve.left {
		width: 100%;
		height: 200px;
		margin-top: -165px;
		z-index: 10;
		background: url('~/assets/images/contentblock-curve-top.svg') no-repeat top right;
		background-size: cover;
		position: relative;
		inset: auto;
	}
}

@media (max-width: 600px) {
	.contentblock-image {
		iframe {
			min-height: 230px;
		}
	}

	.has-video {
		.contentblock-image {
			z-index: 13;
		}
	}
}
</style>
